import CoverImg from '~/assets/cover.png';

const DEFAULT_TITLE = 'Let AI do the work for you - AI Perfect Assistant';
const DEFAULT_DESCRIPTION =
    'Generate stunning PowerPoint slides, reply to messages in Outlook & Teams, craft elegant documents in Microsoft Word - all with the help of AI.';

export const generateMeta = ({
    title = DEFAULT_TITLE,
    description = DEFAULT_DESCRIPTION,
}) => {
    const appName = 'AI Perfect Assistant';
    const coverImg = `https://perfectassistant.ai${CoverImg}`;

    return [
        {
            title: title,
        },
        {
            description,
        },
        {
            property: 'description',
            content: description,
        },
        {
            property: 'og:type',
            content: 'website',
        },
        {
            property: 'og:title',
            content: title,
        },
        {
            property: 'og:description',
            content: description,
        },
        {
            property: 'og:image',
            content: coverImg,
        },
        {
            property: 'og:image:width',
            content: 1200,
        },
        {
            property: 'og:image:height',
            content: 630,
        },
        {
            property: 'og:site_name',
            content: appName,
        },
        {
            property: 'og:image:alt',
            content: title,
        },
        {
            'script:ld+json': {
                '@context': 'https://schema.org',
                '@type': 'SoftwareApplication',
                name: appName,
                operatingSystem: 'Microsoft365',
                applicationCategory: 'BusinessApplication',
                aggregateRating: {
                    '@type': 'AggregateRating',
                    ratingValue: '4.9',
                    ratingCount: '65',
                },
                description: description,
                image: {
                    '@type': 'ImageObject',
                    url: coverImg,
                    width: 1200,
                    height: 630,
                },
                review: [
                    {
                        '@type': 'Review',
                        reviewRating: {
                            '@type': 'Rating',
                            ratingValue: '5',
                        },
                        author: {
                            '@type': 'Person',
                            name: 'Lisa Sharpe',
                        },
                    },
                    {
                        '@type': 'Review',
                        reviewRating: {
                            '@type': 'Rating',
                            ratingValue: '5',
                        },
                        author: {
                            '@type': 'Person',
                            name: 'Fernando Rodriguez',
                        },
                    },
                ],
                offers: {
                    '@type': 'Offer',
                    price: '19.99',
                    priceCurrency: 'USD',
                },
            },
        },
    ];
};
